import { makeStyles } from "@material-ui/core/styles";

const topSideText = {
  color: "Black",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "16px",
};

const botSideText = {
  color: "rgba(0,0,0,0.4)",
  fontWeight: 400,
  fontSize: "12px",
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 10,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0, 3),
    boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.15)",
  },
  firstNameSkeleton: {
    width: 39,
    height: 12,
    marginRight: theme.spacing(0.5),
  },
  mainText: {
    color: "rgba(0,0,0,0.8)",
    fontSize: "24px",
    fontWeight: 400,
  },
  lastNameSkeleton: {
    width: 57,
    height: 12,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
  },
  sideLeft: {
    display: "flex",
    margin: theme.spacing(2, 0),
  },
  sideText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(0, 1.5),
    fontFamily: "Poppins",
  },
  topLeftSideText: {
    ...topSideText,
  },
  botLeftSideText: {
    ...botSideText,
    textTransform: "capitalize",
  },
  topRightSideText: {
    ...topSideText,
    textAlign: "right",
    paddingTop: theme.spacing(0.5),
    textTransform: "capitalize",
  },
  botRightSideText: {
    ...botSideText,
    textAlign: "right",
    paddingBottom: theme.spacing(0.5),
    textTransform: "capitalize",
  },
  avatar: {
    background: "#a9c9ff !important",
    color: "#486494 !important",
  },
  bottomContentContainer: (props?: { variant?: "narrow" | "" }) => ({
    display: "flex",
    flexDirection: "column",
    width: props?.variant === "narrow" ? "55vw" : "70vw",
    margin: "0 auto",
  }),
  backIcon: {
    color: theme.palette.darkGrey.main,
  },
  moreIcon: {
    color: theme.palette.gray2.main,
  },
  bottomContentText: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2.5),
    "& h2": {
      color: "rgba(0,0,0,0.8)",
      fontSize: "24px",
      fontWeight: 400,
      margin: 0,
    },
    "& p": {
      color: theme.palette.primary.main,
      fontSize: "14px",
      fontWeight: 500,
      margin: 0,
    },
  },
}));

export default useStyles;
